import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import amplitude from 'amplitude-js';
import { togglePopup } from 'apps/auth/actions/appAction';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';

const TextPopup = ({ popupRef = null, ...props }) => {
    useEffect(() => {
        if (props.eventInfo) {
            amplitude.getInstance().logEvent(props.eventInfo.name, props.eventInfo.params);
        }
    }, []);

    const getText = (text) => {
        return <DangerouslyHtml dangerouslyHtml={text} />;
    };

    const onClick = () => {
        if (props.onClick) {
            props.onClick();
        }
        if (popupRef?.current) {
            popupRef.current?.close();
        } else {
            props.togglePopup(false);
        }
    };

    return (
        <SimplePopup text={getText(props.text)} popupRef={popupRef}>
            <PopupButton iconName="check" text={props.buttonText} onClick={onClick} />
        </SimplePopup>
    );
};

export default connect(null, { togglePopup })(TextPopup);

TextPopup.propTypes = {
    onClick: PropTypes.func,
    popupRef: PropTypes.shape({ current: PropTypes.object }),
};
